var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25.063,
    viewBox: "0 0 30 25.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-volume-high",
    "data-name": "Icon ionic-ios-volume-high",
    transform: "translate(-4.535 -6.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M16.355,10.243a1.213,1.213,0,0,0-.54-.125,1.255,1.255,0,0,0-.783.274l-5.107,4.12H5.788a1.257,1.257,0,0,0-1.253,1.253v6.266a1.257,1.257,0,0,0,1.253,1.253H9.924L15.031,27.4a1.272,1.272,0,0,0,.783.274,1.213,1.213,0,0,0,.54-.125,1.253,1.253,0,0,0,.713-1.128V11.379A1.256,1.256,0,0,0,16.355,10.243Z",
    transform: "translate(0 0.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M32.153,19.282A17.1,17.1,0,0,0,27.031,7.024a.942.942,0,0,0-1.324,1.339,15.221,15.221,0,0,1,4.559,10.919h0A15.253,15.253,0,0,1,25.707,30.2a.941.941,0,0,0-.008,1.332.919.919,0,0,0,.666.282.939.939,0,0,0,.658-.274,17.062,17.062,0,0,0,5.131-12.258Z",
    transform: "translate(2.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M27.6,18.95h0a12.722,12.722,0,0,0-3.666-9A.942.942,0,1,0,22.6,11.274a10.874,10.874,0,0,1,3.125,7.684h0A10.874,10.874,0,0,1,22.6,26.642a.944.944,0,0,0,.666,1.606.919.919,0,0,0,.666-.282A12.793,12.793,0,0,0,27.6,18.95Z",
    transform: "translate(2.028 0.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M20.38,12.861a.942.942,0,1,0-1.339,1.324,6.269,6.269,0,0,1,1.8,4.433h0a6.3,6.3,0,0,1-1.8,4.433.944.944,0,0,0,.666,1.606.919.919,0,0,0,.666-.282,8.13,8.13,0,0,0,2.342-5.749h0A8.113,8.113,0,0,0,20.38,12.861Z",
    transform: "translate(1.623 0.665)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.20d6671284b6b34beaf5d51ce65b4492.svg";
export { ForwardRef as ReactComponent };